import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';

// draft, initial, modified, completed
export const StepStatus = {
  DRAFT: 'draft',
  INITIAL: 'initial',
  MODIFIED: 'modified',
  COMPLETED: 'completed',
};
const initialState = {
  billingEntity: null,
  step1: {
    status: StepStatus.DRAFT,
    editableStatus: false,
    errorMessage: '',
    data: {
      country: 'India',
      pan: '',
      gst: '',
      companyName: '',
      composition: '',
      landmark: '',
      street: '',
      city: '',
      state: '',
      pincode: '',
    },
  },
  step2: {
    status: StepStatus.DRAFT,
    errorMessage: '',
    data: {
      expiryDate: '',
      errorMessage: '',
      proposedCreditPeriod: '',
      annualInterestRate: '',
      dealType: '',
    },
  },
  step3: {
    status: StepStatus.DRAFT,
    errorMessage: '',
    data: {},
  },
  step5: {
    status: StepStatus.DRAFT,
    errorMessage: '',
    data: {},
  },
};

export const onboardingSlice = createSlice({
  name: 'onboarding',
  initialState,
  reducers: {
    updateBillingEntity: (state, action: PayloadAction<any>) => {
      state.billingEntity = action.payload;
    },
    updateStep1Status: (state, action: PayloadAction<any>) => {
      state.step1.status = action.payload;
    },
    updateStep1Data: (state, action: PayloadAction<any>) => {
      state.step1.status = StepStatus.MODIFIED;
      state.step1.data = { ...action.payload };
    },
    updateStep1: (state, action: PayloadAction<any>) => {
      state.step1.status = StepStatus.INITIAL;
      state.step1.editableStatus = action.payload.editableStatus;
      state.step1.data = { ...action.payload.data };
      state.step1.errorMessage = action.payload.errorMessage;
    },
    updateStep1ErrorMessage: (state, action: PayloadAction<any>) => {
      state.step1.errorMessage = action.payload;
    },
    updateStep2Status: (state, action: PayloadAction<any>) => {
      state.step2.status = action.payload;
    },
    updateStep2Data: (state, action: PayloadAction<any>) => {
      state.step2.status = StepStatus.MODIFIED;
      state.step2.data = { ...action.payload };
    },
    updateStep2: (state, action: PayloadAction<any>) => {
      state.step2.status = StepStatus.INITIAL;
      state.step2.data = { ...action.payload.data };
      state.step2.errorMessage = action.payload.errorMessage;
    },
    updateStep2ErrorMessage: (state, action: PayloadAction<any>) => {
      state.step2.errorMessage = action.payload;
    },
    updateStep3Status: (state, action: PayloadAction<any>) => {
      state.step3.status = action.payload;
    },
    updateStep3Data: (state, action: PayloadAction<any>) => {
      state.step3.status = StepStatus.MODIFIED;
      state.step3.data = { ...action.payload };
    },
    updateStep3: (state, action: PayloadAction<any>) => {
      state.step3.status = StepStatus.INITIAL;
      state.step3.data = { ...action.payload.data };
      state.step3.errorMessage = action.payload.errorMessage;
    },
    updateStep3ErrorMessage: (state, action: PayloadAction<any>) => {
      state.step3.errorMessage = action.payload;
    },
    updateStep5Status: (state, action: PayloadAction<any>) => {
      state.step5.status = action.payload;
    },
    updateStep5Data: (state, action: PayloadAction<any>) => {
      state.step5.status = StepStatus.MODIFIED;
      state.step5.data = { ...action.payload };
    },
    updateStep5: (state, action: PayloadAction<any>) => {
      state.step5.status = StepStatus.INITIAL;
      state.step5.data = { ...action.payload.data };
      state.step5.errorMessage = action.payload.errorMessage;
    },
    updateStep5ErrorMessage: (state, action: PayloadAction<any>) => {
      state.step5.errorMessage = action.payload;
    },
  },
});

// Action creators are generated for each case reducer function
export const {
  updateBillingEntity,
  updateStep1,
  updateStep1Status,
  updateStep1Data,
  updateStep1ErrorMessage,
  updateStep2Status,
  updateStep2Data,
  updateStep2,
  updateStep2ErrorMessage,
  updateStep3Status,
  updateStep3Data,
  updateStep3,
  updateStep3ErrorMessage,
  updateStep5Status,
  updateStep5Data,
  updateStep5,
  updateStep5ErrorMessage,
} = onboardingSlice.actions;

export default onboardingSlice.reducer;
